export default __webpack_public_path__ + "static/media/congo.6e66646b.mp3";